/*
 * Un solo sitio para hablar con la API: dónde vive, cómo se firma, cómo fallan
 * las respuestas.
 *
 * La sesión vive en localStorage: el token que emite la API después de entrar con
 * Google (nexlum_token, también lo leen las páginas legacy) y quién soy
 * (nexlum_quien), que ya no se elige: lo dice la lista de accesos del servidor.
 */

// En local (demo_local.py o `vite dev` con proxy) la API está en el mismo origen.
// En cualquier otro sitio, en Azure. VITE_API_BASE en .env lo sobreescribe.
const LOCAL = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (LOCAL ? "" : "https://ca-nexlum-os-api.wittydune-b449b522.centralus.azurecontainerapps.io");

export class ErrorApi extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export type SesionApi = { token: string; expira: number; email: string; persona_id: string; nombre: string | null };

export const sesion = {
  token(): string {
    const expira = Number(localStorage.getItem("nexlum_expira") ?? 0);
    return expira * 1000 > Date.now() ? localStorage.getItem("nexlum_token") ?? "" : "";
  },
  quien: (): string => localStorage.getItem("nexlum_quien") ?? "",
  email: (): string => localStorage.getItem("nexlum_email") ?? "",
  entrar(s: SesionApi): void {
    localStorage.setItem("nexlum_token", s.token);
    localStorage.setItem("nexlum_expira", String(s.expira));
    localStorage.setItem("nexlum_quien", s.persona_id);
    localStorage.setItem("nexlum_email", s.email);
  },
  salir(): void {
    for (const k of ["nexlum_token", "nexlum_expira", "nexlum_email", "nexlum_llave"]) localStorage.removeItem(k);
    // Sin esto, Google volvería a elegir la misma cuenta sola al regresar a la entrada.
    window.google?.accounts.id.disableAutoSelect();
  },
};

type Opciones = { method?: "GET" | "POST"; body?: unknown; keepalive?: boolean };

export async function api<T>(ruta: string, opciones: Opciones = {}): Promise<T> {
  const r = await fetch(API_BASE + ruta, {
    method: opciones.method ?? (opciones.body !== undefined ? "POST" : "GET"),
    headers: { "Content-Type": "application/json", ...(sesion.token() ? { Authorization: `Bearer ${sesion.token()}` } : {}) },
    body: opciones.body !== undefined ? JSON.stringify(opciones.body) : undefined,
    keepalive: opciones.keepalive,
  });
  if (!r.ok) {
    let detalle = r.statusText;
    try {
      const j = (await r.json()) as { detail?: unknown };
      if (typeof j.detail === "string") detalle = j.detail;
      else if (j.detail) detalle = JSON.stringify(j.detail);
    } catch {
      /* sin cuerpo JSON: nos quedamos con el statusText */
    }
    if (r.status === 401 || r.status === 403) sesion.salir();
    throw new ErrorApi(r.status, detalle);
  }
  return (await r.json()) as T;
}

// Ids cortos y únicos para lo que se crea desde el navegador (interacciones,
// sesiones, personas). No son secretos ni ordenables, solo distintos.
export function idNuevo(prefijo: string): string {
  return `${prefijo}-${Date.now().toString(36)}${Math.floor(Math.random() * 1e3).toString(36)}`;
}
